import { ReactNode, useEffect, useMemo } from 'react';

import { configureCache } from '@growthbook/growthbook';
import { GrowthBook, GrowthBookPayload, GrowthBookProvider } from '@growthbook/growthbook-react';

import { environment } from '@app/environments/environment';
import { ForcedFeatures } from '@app/state/helpers/cookie-app-router.helpers';

configureCache({ disableCache: true });

export const GrowthbookBaseProvider = ({
    payload,
    forcedFeatures,
    children,
}: {
    payload: GrowthBookPayload | null;
    forcedFeatures: ForcedFeatures;
    children: ReactNode;
}) => {
    const gb = useMemo(() => {
        const instance = new GrowthBook({
            apiHost: environment.GROWTHBOOK.API_HOST,
            clientKey: environment.GROWTHBOOK.CLIENT_KEY,
        });

        if (payload) {
            instance.initSync({ payload });
        }

        const overrides = Object.entries(forcedFeatures).filter(([, v]) => v != null);
        if (overrides.length > 0) {
            instance.setForcedFeatures(new Map(overrides));
        }

        return instance;
    }, [payload, forcedFeatures]);

    useEffect(() => {
        return () => gb.destroy();
    }, [gb]);

    return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
};
